import { render, staticRenderFns } from "./BoxElement.vue?vue&type=template&id=68a5be0e&"
import script from "./BoxElement.vue?vue&type=script&lang=js&"
export * from "./BoxElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports